import { defineMessages } from 'react-intl';

const messages = defineMessages({
  messagingHubTitle: {
    id: 'App.MessagingHub.title',
    defaultMessage: 'Conversations Queue',
  },
  messagingHubSubtitle: {
    id: 'App.MessagingHub.subtitle',
    defaultMessage: 'A list of all previously generated communications',
  },
  errorHeader: {
    id: 'App.MessagingHub.errorHeader',
    defaultMessage: 'Error',
  },
  failedToLoadMessagesError: {
    id: 'App.MessagingHub.failedToLoadMessagesError',
    defaultMessage: 'Failed to load messages. Please try again.',
  },
  noMessagesFound: {
    id: 'App.MessagingHub.noMessagesFound',
    defaultMessage: 'No messages found.',
  },
  loadMore: {
    id: 'App.MessagingHub.loadMore',
    defaultMessage: 'Load More',
  },
  searchPlaceholder: {
    id: 'App.MessagingHub.searchPlaceholder',
    defaultMessage: 'Search by name or phone number',
  },
  filterByProperty: {
    id: 'App.MessagingHub.filterByProperty',
    defaultMessage: 'Property',
  },
  filterByStatus: {
    id: 'App.MessagingHub.filterByStatus',
    defaultMessage: 'Message Status',
  },
  filterByHouseholdStatus: {
    id: 'App.MessagingHub.filterByHouseholdStatus',
    defaultMessage: 'Household Status',
  },
  allProperties: {
    id: 'App.MessagingHub.allProperties',
    defaultMessage: 'All Properties',
  },
  allStatuses: {
    id: 'App.MessagingHub.allStatuses',
    defaultMessage: 'All Statuses',
  },
  newStatus: {
    id: 'App.MessagingHub.newStatus',
    defaultMessage: 'New',
  },
  resolvedStatus: {
    id: 'App.MessagingHub.resolvedStatus',
    defaultMessage: 'Resolved',
  },
  unresolvedStatus: {
    id: 'App.MessagingHub.unresolvedStatus',
    defaultMessage: 'Unresolved',
  },
  needsHelpStatus: {
    id: 'App.MessagingHub.needsHelpStatus',
    defaultMessage: 'Leslie Needs Help',
  },
  prospectStatus: {
    id: 'App.MessagingHub.prospectStatus',
    defaultMessage: 'Prospect',
  },
  applicantStatus: {
    id: 'App.MessagingHub.applicantStatus',
    defaultMessage: 'Applicant',
  },
  residentStatus: {
    id: 'App.MessagingHub.residentStatus',
    defaultMessage: 'Resident',
  },
  priorResidentStatus: {
    id: 'App.MessagingHub.priorResidentStatus',
    defaultMessage: 'Prior Resident',
  },
  search: {
    id: 'App.General.search',
    defaultMessage: 'Search',
  },
  selectConversation: {
    id: 'App.MessagingHub.selectConversation',
    defaultMessage: 'Select a conversation to view messages',
  },
  failedToSendMessageError: {
    id: 'App.MessagingHub.failedToSendMessageError',
    defaultMessage: 'Failed to send message. Please try again.',
  },
  failedToUpdateStatusError: {
    id: 'App.MessagingHub.failedToUpdateStatusError',
    defaultMessage: 'Failed to update conversation status. Please try again.',
  },
  searchResultsHint: {
    id: 'App.MessagingHub.searchResultsHint',
    defaultMessage:
      'Showing the first 20 results. Continue typing to refine your search.',
  },
  failedToLoadCommunicationPreferencesErrorMsg: {
    id: 'App.MessagingHub.failedToLoadCommunicationPreferencesErrorMsg',
    defaultMessage: 'Failed to load communication preferences.',
  },
  userNoLongerOptedInErrorMsg: {
    id: 'App.MessagingHub.userNoLongerOptedInErrorMsg',
    defaultMessage: 'The recipient has opted out of receiving messages.',
  },
});

export default messages;
